const MAP = {
  draft: { label: "Draft", cls: "bg-stone-100 text-stone-600 border-stone-300" },
  submitted: { label: "In Review", cls: "bg-amber-50 text-amber-700 border-amber-300" },
  published: { label: "Published", cls: "bg-emerald-50 text-emerald-700 border-emerald-300" },
  rejected: { label: "Needs Changes", cls: "bg-red-50 text-red-700 border-red-300" },
};

export default function StatusBadge({ status, className = "" }) {
  const s = MAP[status] || MAP.draft;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold uppercase tracking-wider border ${s.cls} ${className}`}
    >
      {s.label}
    </span>
  );
}
